export default {
	"order.ShoppingMallPaymentResultPageAdvertisingPopUpWindow": "Shopping mall payment result page_Advertising pop-up window",
	"order.ParameterError": "Parameter error!",
	"order.ForMoreInformationYouCanLogInToTheCallAppletOrAppToFollow": "For more information, you can log in to the [Call] applet or app to follow.",
	"order.checkOrder": "check order",
	"order.share": "share",
	"order.LongPressToIdentifyTheQRCode": "Long press to identify the QR code",
	"order.EnterTheCallApplet": "Enter the call applet",
	"order.MallPaymentResultPageAdPopUpWindowClick": "Mall payment result page_Ad pop-up window click"
}